import { platformSwitch } from '@certilogo/design-system/dist/configuration';

import * as web from './web';
import * as native from './native';

export const {
  getGeoProp,
  getGeocodeDetails,
  getAutocompleteSuggestions,
  getCurrentPosition,
  getNearByPlaces,
  getPlaceSearch,
  checkGeolocationAvailability,
} = platformSwitch({
  web,
  native,
});
